import "../layouts/default"
import Swiper, { Navigation, Pagination } from 'swiper';
import { checkResolution } from '../functions/helpers'
import '../ui/slider'
import '../common/lightgallery';
import { scrollToEl } from '../common/anchor'
import './articles-jquery'

Swiper.use([Navigation, Pagination]);

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-articles__body'), (checkResolution('cxs;xs') ? 0 : 40))
        })
    }
}

attachPaginatorEvents()

rEvent.on('Listing.fetchedData', () => {
    attachPaginatorEvents()
})

const initNavScrollLeft = () => {
    if (!document.querySelector('.js-articles-nav .is-selected')) return

    const nav = document.querySelector('.js-articles-nav')
    const selectedItem = nav.querySelector('.is-selected')
    const containerPadding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--container-padding')) || 20
    const maxScrollLeft = nav.scrollWidth - nav.offsetWidth

    if (selectedItem.offsetLeft + selectedItem.offsetWidth + containerPadding > nav.offsetWidth) {
        let initialNavScrollLeft = Math.round(selectedItem.offsetLeft - nav.offsetWidth + (selectedItem.offsetWidth / 2) + (nav.offsetWidth / 2))

        if (initialNavScrollLeft > maxScrollLeft) {
            initialNavScrollLeft = maxScrollLeft
        }

        nav.scroll({
            left: initialNavScrollLeft,
            behavior: 'smooth'
        })
    }
}

if (checkResolution('cxs;xs')) {
    initNavScrollLeft()
}